import { SalaryStats } from 'generated/apolloComponents'
import SalaryChartItem from './SalaryChartItem'

interface IProps {
  statsData: SalaryStats
  type: 'reported' | 'salaryBrackets'
  seniority: 'junior' | 'medium' | 'senior' | 'all'
  employmentType: 'b2b' | 'employment'
  className: string
}
const SalaryChartItemWrapper = ({
  statsData,
  type,
  seniority,
  employmentType,
  className,
}: IProps) => {
  const itemData = statsData?.[type]?.[seniority]?.[employmentType]

  if (!itemData) return null

  return (
    <SalaryChartItem
      spread={itemData.spread}
      value={itemData.value}
      type={employmentType}
      className={className}
    />
  )
}

export default SalaryChartItemWrapper
